export const PAINT_COLORS = {
	Red: '#e8231f', Orange: '#ff8a1c', Yellow: '#f2c21b', Green: '#2bb24c', Blue: '#1f6fe8',
	Purple: '#9b3dff', Pink: '#ff4fb8', White: '#ffffff', Black: '#2b2b2b',
};

export const RAINBOW_PAINT = ['#ff2a2a', '#ff8c1a', '#ffe11a', '#3ad13a', '#1a8cff', '#9b3dff', '#ff3dc8'];
